export default class Weather {
    location: string = '';
}
